module.exports = __webpack_public_path__ + "img/icono-18-1.6a2c1713.png";